<template>
  <li>
    <a
      :data-testid="`viewed-notification-${item.id}`"
      :href="item.actionLink"
      target="_blank"
      @click="$emit('clicked', item.id)"
      class="relative flex items-center justify-between gap-4 p-4 bg-white border rounded-10"
      :class="notificationClass(isNew(item))"
    >
      <div v-if="isNew(item)" class="absolute w-2 h-2 bg-red-500 border rounded-full top-2 right-2 border-slate-200 dark:border-zinc-700">
        <span class="sr-only">New notification</span>
      </div>

      <div class="flex-none w-24">
        <img :src="item.imageUrl" width="96" height="66" alt="" class="border rounded border-slate-300 h-[66px] w-24 object-cover object-top" />
      </div>

      <div class="flex items-baseline gap-4">
        <div class="flex-none w-48 space-y-1 sm:w-64">
          <div>
            <p class="dark:text-zinc-300">{{ item.title }}</p>
            <p class="text-sm text-slate-600 dark:text-zinc-500">{{ item.body }}</p>
          </div>
          <div v-if="item.createdAt" class="text-sm font-semibold dark:text-zinc-500">{{ formatTimeAgo(item.createdAt) }}</div>
        </div>
      </div>
    </a>
  </li>
</template>
<script setup lang="ts">
import { Notification } from '@/store/useNotificationsStore';
import { formatTimeAgo } from '@vueuse/core';

defineProps<{
  item: Notification;
}>();

const $emit = defineEmits(['clicked']);

const isNew = (item: Notification) => !item.viewedAt;
const notificationClass = (isNew: boolean) => {
  if (isNew) {
    return 'bg-slate-100 dark:bg-zinc-700 border-slate-300 dark:border-zinc-700';
  }

  return 'dark:bg-zinc-800 border-slate-200 dark:border-zinc-600';
};
</script>
